import http from "../http"
 export default function () {
   const request=http.post("/globalconfig",null,{
     needLogin:false
   }).then(v =>{
     return v;
   })
   return request;
 }
